import { TokenData } from './../../models/user.data-object';

import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { UserData } from './../../models/user.data-object';

import { LoginService } from 'src/app/services/login.service';
import { AppCoreService } from 'src/app/services/app-core.service';
import { AppTokenService } from 'src/app/services/app-token.service';
// import { TenantService } from 'src/app/services/tenant.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { UserManagementService } from 'src/app/services/user-management.service';
import md5 from 'md5';
import { PasswordValidators } from 'src/app/models/password-validators';
import { Utilities } from 'src/app/models/utilities';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: FormGroup;
  emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}';
  loginSubmitted = false;
  userData = new UserData();
  hidePassword = true;
  hideConfirmPassword = true;
  // set the currenr year
  year: number = new Date().getFullYear();
  checkingEmail = false;
  loadPwdSections = false;
  firstLogin = false;
  userid;
  @ViewChild('clientId') clientId!: ElementRef;

  constructor(
    private appCoreService: AppCoreService,
    private appTokenService: AppTokenService,
    private loginService: LoginService,
    private userManagementService: UserManagementService,
    private router: Router,
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private el: ElementRef,
    private cdRef: ChangeDetectorRef,
    private utilities: Utilities
  ) {

  }


  ngOnInit(): void {
    // check user login status
    this.appCoreService.CheckUserLoggedIn().subscribe(res => {
      if (res) {
        this.router.navigate(['/home']);
      }
    });

    this.loginForm = this.formBuilder.group({
      ddlLoginAs: ['Client'],
      txtClientId: [null, Validators.compose([Validators.required])],
      email: ['', Validators.compose([Validators.pattern(this.emailPattern), Validators.required])],
      password: ['', Validators.compose([Validators.required])],
      txtPassword: new FormControl(
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          PasswordValidators.patternValidator(new RegExp("(?=.*[0-9])"), {
            requiresDigit: true
          }),
          PasswordValidators.patternValidator(new RegExp("(?=.*[A-Z])"), {
            requiresUppercase: true
          }),
          PasswordValidators.patternValidator(new RegExp("(?=.*[a-z])"), {
            requiresLowercase: true
          }),
          PasswordValidators.patternValidator(new RegExp("(?=.*[$@^!%*?&])"), {
            requiresSpecialChars: true
          })
        ])
      ),
      txtConfirmPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(8)
      ]),
    },
      { validators: PasswordValidators.MatchValidator }
    );
  }

  ngAfterViewInit(): void {
    this.clientId.nativeElement.focus();
  }

  carouselOption: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    nav: false,
    dots: true,
    responsive: {
      680: {
        items: 1
      },
    }
  }

  get l(): any { return this.loginForm.controls; }

  validateEmail(): void {
    // console.log('working')
    try {
      const requestObj = {
        logintype: this.loginForm.value.ddlLoginAs,
        clientid: this.loginForm.value.txtClientId,
        email: this.loginForm.value.email,
        mode: 'email'
      };

      // this.ngxLoaderService.start();
      this.loginSubmitted = true;
      if (this.loginForm.get('txtClientId').valid && this.loginForm.get('email').valid) {
        this.checkingEmail = true;
        this.loginService.AuthenticateUser(requestObj).subscribe({
          next: (res) => {
            if (res) {
              if (res?.success) {
                this.loginSubmitted = false;
                this.userid = res.data[0].id;
                if (res.data[0].fl) {
                  this.firstLogin = true;
                  this.appCoreService.showMessage('We have got you covered !! Please set your password now to use the system and then click login.', 'Login for the first time?', 'success');
                  this.loginForm.get('password').disable();
                  this.loginForm.get('txtPassword').enable();
                  this.loginForm.get('txtConfirmPassword').enable();
                } else {
                  this.firstLogin = false;
                  this.loginForm.get('password').enable();
                  this.loginForm.get('txtPassword').disable();
                  this.loginForm.get('txtConfirmPassword').disable();
                }

                this.checkingEmail = false;
                this.loadPwdSections = true;
              } else {
                this.appCoreService.showMessage(res?.message, 'Invalid Credentials !', 'error');
              }
            }
          },
          error: (err) => {
            // console.log(err);
            this.checkingEmail = false;
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Please contact your system administrator', 'Invalid Credentials !', 'error');
          },
          complete: () => {
            // console.log('complete');
            this.ngxLoaderService.stop();
            this.checkingEmail = false;

            this.cdRef.detectChanges();

            // After change detection, query the password input
             this.el.nativeElement.querySelector(this.firstLogin? 'input[formControlName="txtPassword"]': 'input[formControlName="password"]')?.focus();
          }
        });
      } else {

        // this.loginForm.updateValueAndValidity();
      }


    } catch (e) {

    }
  }

  // onLoginAsChange(): void {
  //   if (this.clientInput) {
  //     this.clientInput.nativeElement.focus();
  //   }
  // }

  // onEnter(nextElement: HTMLInputElement): void {
  //   if (nextElement) {
  //     nextElement.focus();
  //   }
  // }

  authenticateUser(): void {
    try {
      this.loginSubmitted = true;
      if (this.loginForm.valid) {
        // console.log(this.loginForm.value.ddlLoginAs);
        let inputPassword = this.loginForm.value.password;
        if (this.firstLogin) {
          inputPassword = this.loginForm.get('txtPassword').value.trim();
        }
        let hashedPassword = md5(inputPassword);

        const requestObj = {
          logintype: this.loginForm.value.ddlLoginAs,
          clientid: this.loginForm.value.txtClientId,
          email: this.loginForm.value.email,
          password: hashedPassword,
          deviceid: 1,
          id: this.userid,
          fl: this.firstLogin
        };

        this.ngxLoaderService.start();
        this.loginService.AuthenticateUser(requestObj).subscribe({
          next: (res) => {
            if (res) {
              if (res?.success) {
                if (res.data.length) {
                  this.userData.metaInfo = res.data[0].meta_info;
                  this.userData.userName = res.data[0].username;
                  this.userData.sessionid = res.data[0].sessionid;
                  // const userData = new UserData();
                  // userData.isUserLoggedIn = true;
                  // userData.clientId = res.body.data[0].client_id;
                  // userData.tenantId = res.body.data[0].tenant_id;
                  // userData.emailId = res.body.data[0].email_id;
                  // userData.userId = res.body.data[0].user_id;
                  // userData.uId = res.body.data[0].id;
                  // userData.roleId = res.body.data[0].role_id;
                  // userData.tenantLogo = res.body.data[0].tenantLogo;

                  if (res.accesstoken) {
                    const tokenData: TokenData = {
                      accesstoken: res.accesstoken,
                      refreshtoken: res.refreshtoken,
                      type: 'user'
                    }
                    this.appTokenService.SetToken(tokenData);
                    const decoded = this.appTokenService.DecodeToken(res.accesstoken);
                    // console.log('decoded', decoded);
                    this.userData.isUserLoggedIn = true;
                    this.userData.tenant = decoded.data.tenant;
                    this.userData.emailId = decoded.data.email;
                    this.userData.userId = decoded.data.userid;
                    this.userData.groupId = decoded.data.groupid;
                    this.userData.roleId = decoded.data.roleid;
                    this.userData.clientId = decoded.data.clientid;
                    this.userData.accessType = decoded.data.accesstype;
                    this.userData.metaInfo = JSON.parse(decoded.data.metainfo);
                    // console.log('this.userData', this.userData);
                    // get user details
                    if (this.userData.userId) {
                      this.ngxLoaderService.stop();
                      if (this.userData?.metaInfo?.resetpassword) {
                        this.appCoreService.SetUserData(this.userData);
                        this.router.navigate(['/account/reset-password']);
                        return;
                      }
                      this.ngxLoaderService.start();
                      this.userManagementService.GetById(this.userData.userId).subscribe((res) => {
                        if (res && res?.success) {
                          // console.log('res', res);
                          this.userData.servicecenters = res.data[0]?.info?.servicecenters;
                          this.userData.config = res.data[0]?.config;
                          this.appCoreService.SetUserData(this.userData);

                          const defaultSC = res.data[0].info.servicecenters?.filter(x => x.isdefault === true);
                          // console.log('defaultSC', defaultSC);
                          if (defaultSC?.length) {
                            this.appCoreService.SetServiceCenter(defaultSC[0].id);
                          } else {
                            this.appCoreService.SetServiceCenter(0);
                          }


                          this.ngxLoaderService.stop();
                          // // set user data
                          this.appCoreService.showMessage('Logged in successfully');
                          // // TODO :: role based navigation
                          this.router.navigate(['/home']);

                        }
                      });
                    } else {
                      this.appCoreService.showMessage('Please contact your system administrator', 'Invalid Credentials !', 'error');
                    }

                  }
                } else {
                  // console.log('1', res);
                  this.appCoreService.showMessage('Incorrect emailid or password', 'Invalid Credentials !', 'error');
                }
              } else if (!res?.success) {
                // console.log('2', res);
                this.appCoreService.showMessage('Incorrect emailid or password', 'Invalid Credentials !', 'error');
              }
            }

          },
          error: (err) => {
            // console.log(err);
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage('Please contact your system administrator', 'Invalid Credentials !', 'error');
          },
          complete: () => {
            // console.log('complete');
            this.ngxLoaderService.stop();
          }
        });

      }
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }

  }



}